import { useHistory } from 'react-router-dom';
import { useWaterSystemSearchModal } from '../components/reuseableComponents/WaterSystemSearchModalContext';

// Hook to navigate user to the appropriate route when they select a new water system
export const useNavigateOnWaterSystemChange = () => {
  const history = useHistory();
  const { findMenuItemByCode } = useWaterSystemSearchModal();

  const navigate = (currentPath) => {
    // Dynamically load routes to avoid circular dependency
    const archiveRoutes = require('../routes/archiveRoutes').archiveRoutes;
    const backflowRoutes = require('../routes/backflowRoutes').backflowRoutes;
    const ddwAdminRoutes = require('../routes/ddwAdminRoutes').ddwAdminRoutes;
    const enforcementRoutes = require('../routes/enforcementRoutes').enforcementRoutes;
    const engineeringRoutes = require('../routes/engineeringRoutes').engineeringRoutes;
    const loanTrackerRoutes = require('../routes/loanTrackerRoutes').loanTrackerRoutes;
    const portalRoutes = require('../routes/portalRoutes').portalRoutes;
    const publicRoutes = require('../routes/publicRoutes').publicRoutes;
    const siteVisitRoutes = require('../routes/siteVisitRoutes').siteVisitRoutes;
    const sourceProtectionRoutes = require('../routes/sourceProtectionRoutes').sourceProtectionRoutes;

    const ALL_ROUTES = [
      ...archiveRoutes,
      ...backflowRoutes,
      ...ddwAdminRoutes,
      ...enforcementRoutes,
      ...engineeringRoutes,
      ...loanTrackerRoutes,
      ...portalRoutes,
      ...publicRoutes,
      ...siteVisitRoutes,
      ...sourceProtectionRoutes,
    ];

    // Split path into segments and remove empty strings
    let segments = currentPath.split('/').filter(Boolean);
    const isAtRoot = segments.length === 0;

    while (true) {
      const testPath = segments.length > 0 ? '/' + segments.join('/') : '/';
      const matchingRoute = ALL_ROUTES.find((route) => route.path === testPath);

      if (matchingRoute && matchingRoute.selectedSystemRouteToItemCode) {
        const code = matchingRoute.selectedSystemRouteToItemCode;
        const menuItem = findMenuItemByCode(code);

        if (menuItem && menuItem.url_route) {
          history.push(menuItem.url_route);
          return;
        }
      }

      if (segments.length === 0) break;
      segments.pop();

      if (segments.length === 0 && !isAtRoot) break;
    }
  };

  return navigate;
};
